import { Locale } from "date-fns";
import enUSLocale from "date-fns/locale/en-US/index";
import esLocale from "date-fns/locale/es/index";
import kkLocale from "date-fns/locale/kk/index";
import ptLocale from "date-fns/locale/pt/index";
import roLocale from "date-fns/locale/ro/index";
import ruLocale from "date-fns/locale/ru/index";
import ukLocale from "date-fns/locale/uk/index";

export function getDateFnsLocaleByString(languageCode: string): Locale {
  let locale: Locale;
  switch (languageCode) {
    case "ru":
      locale = ruLocale;
      break;
    case "en":
      locale = enUSLocale;
      break;
    case "es":
      locale = esLocale;
      break;
    case "kk":
      locale = kkLocale;
      break;
    case "pt":
      locale = ptLocale;
      break;
    case "ro":
      locale = roLocale;
      break;
    case "uk":
      locale = ukLocale;
      break;
    default:
      locale = enUSLocale;
      break;
  }
  return locale;
}
